

export const updatePartsOfTeamMember = async (functionParameters = {}) => {

    const recursiveUpdate = (await import(/* webpackPrefetch: true */ "../general/recursiveUpdate")).recursiveUpdate;

    functionParameters["submissionFuncPath"] = "apps/teamMembers/updatePartsOfTeamMember";
    functionParameters["sideMenuToUse"] = "teamMembers";
    return await recursiveUpdate(functionParameters);


};
